import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

import Typography from '@material-ui/core/Typography';

import Link from '../Link/Link';
import CallButton from '../../components/CallButton/CallButton';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ContactDetails extends React.Component {
  render() {
    const { classes, forceEnglish } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.contactInfoContainer}>
          <div className={classes.contactInfoAction}>
            {isMobile && (
              <CallButton phoneNumber={portalContent.APP_CALL_NUMBER} />
            )}
          </div>
          <div className={classes.contactInfo}>
            <Typography className={classes.detailText}>
              {forceEnglish
                ? portalContent.APP_SUPPORT_MESSAGE_1_EN
                : portalContent.APP_SUPPORT_MESSAGE_1}
            </Typography>
            <Typography className={classes.detailText}>
              {forceEnglish
                ? portalContent.APP_SUPPORT_MESSAGE_2_EN
                : portalContent.APP_SUPPORT_MESSAGE_2}
            </Typography>
            <Typography className={classes.detailText}>
              {forceEnglish
                ? portalContent.APP_SUPPORT_MESSAGE_3_EN
                : portalContent.APP_SUPPORT_MESSAGE_3}
            </Typography>
            <Typography className={classes.detailText}>
              {isMobile ? (
                <Link
                  label={portalContent.APP_CALL_NUMBER}
                  link={'tel:' + portalContent.APP_CALL_NUMBER}
                  className={classes.dialogMobileLink}
                />
              ) : (
                portalContent.APP_CALL_NUMBER
              )}
            </Typography>
          </div>
        </div>
      </div>
    );
  }
}

ContactDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  forceEnglish: PropTypes.bool,
};

ContactDetails.defaultProps = {
  forceEnglish: false,
};

export default withStyles(styles)(ContactDetails);
